import { type ClaimOfferResponse } from '../click-to-claim.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getClaimErrorMessage = (response: ClaimOfferResponse): string | undefined => {
  return response.result === 'Reward' ? undefined : response.errorMessage;
};

export const toErrorMessage = (raw: unknown): string | undefined => {
  if (raw == null) return undefined;

  if (raw instanceof Error) return raw.message;

  if (typeof raw === 'string') return raw;

  if (typeof raw === 'object' && 'message' in raw && typeof raw.message === 'string') {
    return raw.message;
  }

  try {
    return JSON.stringify(raw);
  } catch {
    return undefined; // circular reference
  }
};
